/**
 * Logo info menu anchor and About/Contact dialogs.
 * Shared by account side menu and `/app` AppDrawer.
 */
import { DialogState } from "@/lib/mobx/DialogState";
import { action, computed, makeAutoObservable, observable } from "mobx";

export class LogoInfoMenuState {
  logoMenuAnchor: HTMLElement | null = null;
  aboutDialog = new DialogState();
  contactDialog = new DialogState();

  constructor() {
    makeAutoObservable(this, {
      logoMenuAnchor: observable,
      openLogoMenu: action,
      closeLogoMenu: action,
    });
  }

  get isOpen() {
    return Boolean(this.logoMenuAnchor);
  }

  openLogoMenu(anchor: HTMLElement) {
    this.logoMenuAnchor = anchor;
  }

  closeLogoMenu() {
    this.logoMenuAnchor = null;
  }
}

export const logoInfoMenuState = new LogoInfoMenuState();
